import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'euroSymbol'
})
export class EuroSymbolPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;
    return value.replace(' EUR', ' €');
  }

}
